import styled from 'styled-components';

import BaseWrapper from 'shared/components/presentational/Wrapper/Wrapper';

export const Wrapper = styled(BaseWrapper)`
  margin-top: 0 !important;
`;
